import React from 'react';
import Breadcrumbs from './Breadcrumbs';
import Content from './content';
import Footer from './footer';
import Header from './header';

const About = () => {
    return (
        <>
            <Breadcrumbs name="About Us" linename="About" />
            <Content/>
        </>
    )
}

export default About;
